import { Component } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { TabitPayService } from 'src/app/tabit-pay/tabit-pay.service';

@Component({
    selector: 'app-tabitpay-ticket-offers',
    templateUrl: './tabitpay-ticket-offers.component.html',
    styleUrl: './tabitpay-ticket-offers.component.scss',
    standalone: false
})
export class TabitpayTicketOffersComponent {
	$storage: any;
	constructor(
		public appService: AppService,
		public tabitPayService: TabitPayService,

	) {
		this.$storage = this.tabitPayService.$storage;
	}
}
